import React from "react";

import { getIntegrationForKey, type renderPillArgument } from "../actionItemIntegration";
import { WidgetInner } from "../actionItemIntegration/Widget";

export const mondaySpecificDataNodeTypename = "MondayActionItemIntegrationSpecificDataNode";

export function MondayActionItemIntegrationLinkWidget({ actionItemLink, customClassName }: renderPillArgument) {
	if (actionItemLink.integrationData.__typename !== mondaySpecificDataNodeTypename) {
		throw new Error("Incorrect integration to render pill");
	}

	const mondayData = actionItemLink.integrationData;
	const { externalBoardId, externalTaskId, externalGroupName, externalBoardName, mondayUser } = mondayData;

	const updating = actionItemLink.syncStatus !== "DONE_SYNCING_EXTERNALLY";

	const workspace = `${mondayUser.accountSlug}.monday.com`;
	const pulsePath = externalTaskId ? `pulses/${externalTaskId}` : "";
	const url = `https://${workspace}/boards/${externalBoardId}/${pulsePath}`;

	const tooltip = externalBoardName ?? undefined;

	const logo = getIntegrationForKey("MONDAY").logo;

	return (
		<WidgetInner tooltip={tooltip} logo={logo} updating={updating} url={url} customClassName={customClassName}>
			{externalGroupName}
		</WidgetInner>
	);
}
